import EventEmitter from "eventemitter3";

export const focusEmitter = new EventEmitter();
